import _defineProperty from "@babel/runtime/helpers/defineProperty";
import Button from '@atlaskit/button/standard-button';
import AkFeedbackCollector from '@atlaskit/feedback-collector';
import EditorFeedbackIcon from '@atlaskit/icon/glyph/editor/feedback';
import { ButtonClickedEvent, withAnalytics } from '@atlassian/mpac-analytics';
import { withStatsig } from '@atlassian/mpac-feature-flags';
import { ErrorKeeper } from '@atlassian/mpac-utils';
import React, { Component } from 'react';
import { ANALYTICS_SUBJECT_ID_FEEDBACK_CLICKED_BUTTON, ANALYTICS_SUBJECT_ID_FEEDBACK_SUBMIT_BUTTON } from '../../analytics/Events';
import { makeFlag, makeFlagDescription, SUCCESS_APPEARANCE } from '../../records/Flag';
import { getLocationPath } from '../../utils/routes-utils';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// Aether Feedback goes to https://customerfeedback.atlassian.net/jira/servicedesk/projects/AMMF
const AETHER_ENTRYPOINT_ID = '382c9b92-a4ff-45d1-bd4d-237ce0f5ac9f';
class FeedbackCollector extends Component {
  constructor() {
    super(...arguments);
    _defineProperty(this, "state", {
      isOpen: false
    });
    _defineProperty(this, "open", () => {
      this.props.fireAnalyticsEvent({
        eventType: ButtonClickedEvent,
        actionSubjectId: ANALYTICS_SUBJECT_ID_FEEDBACK_CLICKED_BUTTON
      });
      this.setState({
        isOpen: true
      });
    });
    _defineProperty(this, "close", () => this.setState({
      isOpen: false
    }));
    _defineProperty(this, "submit", feedbackValues => {
      this.props.fireAnalyticsEvent({
        eventType: ButtonClickedEvent,
        actionSubjectId: ANALYTICS_SUBJECT_ID_FEEDBACK_SUBMIT_BUTTON,
        attributes: {
          feedbackType: feedbackValues === null || feedbackValues === void 0 ? void 0 : feedbackValues.type,
          feedbackDescription: feedbackValues === null || feedbackValues === void 0 ? void 0 : feedbackValues.description
        }
      });
      this.props.onFeedbackSubmit();
    });
  }
  render() {
    const {
      isOpen
    } = this.state;
    const additionalFields = [{
      id: 'customfield_10047',
      value: JSON.stringify({
        pathname: getLocationPath(),
        context: this.props.selectedContext.id,
        errorsObj: ErrorKeeper.getLastNMinutesErrors()
      }, null, 2)
    }];
    return /*#__PURE__*/_jsxs("div", {
      className: this.props.className,
      children: [/*#__PURE__*/_jsx(Button, {
        appearance: "subtle-link",
        onClick: this.open,
        iconBefore: /*#__PURE__*/_jsx(EditorFeedbackIcon, {
          label: ""
        }),
        children: "Feedback"
      }), isOpen && /*#__PURE__*/_jsx(AkFeedbackCollector, {
        onClose: this.close,
        onSubmit: this.submit,
        atlassianAccountId: this.props.userId,
        name: this.props.userId,
        entrypointId: AETHER_ENTRYPOINT_ID,
        additionalFields: additionalFields
      })]
    });
  }
}

// This is consistent with the Atlaskit FeedbackCollector Flag, to keep the experience consistent across all products.
export const feedbackSuccessFlag = makeFlag({
  autoDismiss: true,
  appearance: SUCCESS_APPEARANCE,
  description: makeFlagDescription({
    primary: 'Your valuable feedback helps us continually improve our products.'
  }),
  key: 'feedbackSent',
  title: 'Thanks!'
});
export default withAnalytics(withStatsig(FeedbackCollector));